import React from 'react';

const AboutSection = () => (
  <section id="quienes-somos" className="py-20 px-6" style={{ background: '#F5F7F6' }} data-testid="about-section">
    <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <figure className="rounded-2xl overflow-hidden shadow-xl">
        <img
          src="/images/sendhapy-equipo.jpg"
          alt="Equipo de SendHapy preparando paquetes para sus clientes"
          className="w-full h-auto block"
          width="1147"
          height="937"
          loading="lazy"
          data-testid="about-foto-equipo"
        />
      </figure>
      <div>
        <p className="text-sm font-semibold uppercase tracking-widest mb-3" style={{ color: 'var(--sendhapy-teal)' }}>
          Quiénes somos
        </p>
        <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: 'var(--sendhapy-teal)' }}>
          Personas reales detrás de cada envío
        </h2>
        <p className="text-lg text-gray-600 mb-4 leading-relaxed">
          SendHapy nació para que comprar en Estados Unidos sea fácil y seguro para todos en Costa Rica.
          Nuestro equipo recibe, revisa y prepara cada paquete como si fuera propio.
        </p>
        <p className="text-lg text-gray-600 leading-relaxed">
          Trabajamos con compromiso y cercanía: te acompañamos desde que compras hasta que tu paquete llega a tus manos.
        </p>
      </div>
    </div>
  </section>
);

export default AboutSection;
